import { render, staticRenderFns } from "./standars.vue?vue&type=template&id=74b361e4&scoped=true"
import script from "./standars.vue?vue&type=script&lang=js"
export * from "./standars.vue?vue&type=script&lang=js"
import style0 from "./standars.vue?vue&type=style&index=0&id=74b361e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b361e4",
  null
  
)

export default component.exports